import { createFileRoute } from '@tanstack/react-router';
import { ApprovalsPage } from '@/features/approvals/pages/approvals-page';

type Search = { focus?: string; tab?: 'pending' | 'approved' | 'rejected' };

export const Route = createFileRoute('/_app/approvals')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    focus: typeof s.focus === 'string' ? s.focus : undefined,
    tab: s.tab === 'approved' || s.tab === 'rejected' || s.tab === 'pending' ? s.tab : undefined,
  }),
  component: ApprovalsPage,
});
